import React from 'react';
export function ForWho() {
  return <section className="w-full py-20 px-6" style={{
    backgroundColor: '#F5F0EB'
  }} data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-53">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-54">
            ¿Esto es para ti?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-55">
          {/* For who */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#E8E0D8]" data-id="element-56">
            <div className="flex items-center gap-3 mb-6" data-id="element-57">
              <span className="text-3xl" role="img" aria-label="Check" data-id="element-58">
                ✅
              </span>
              <h3 className="text-xl font-bold" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-59">
                Esto SÍ es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-60">
              <li className="flex items-start gap-3" data-id="element-61">
                <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-62">
                  ✓
                </span>
                <p style={{
                color: '#6B7280',
                fontFamily: 'Inter, sans-serif'
              }} className="text-base leading-relaxed" data-id="element-63">
                  Eres dueño de propiedades que quiere escalar su negocio{' '}
                  <strong style={{
                  color: '#1A1A1A'
                }} data-id="element-64">
                    sin contratar personal todavía
                  </strong>
                  .
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-65">
                <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-66">
                  ✓
                </span>
                <p style={{
                color: '#6B7280',
                fontFamily: 'Inter, sans-serif'
              }} className="text-base leading-relaxed" data-id="element-67">
                  Eres co-host que gestiona varias unidades y necesita{' '}
                  <strong style={{
                  color: '#1A1A1A'
                }} data-id="element-68">
                    estandarizar procesos
                  </strong>
                  .
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-69">
                <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-70">
                  ✓
                </span>
                <p style={{
                color: '#6B7280',
                fontFamily: 'Inter, sans-serif'
              }} className="text-base leading-relaxed" data-id="element-71">
                  Eres anfitrión nuevo que teme{' '}
                  <strong style={{
                  color: '#1A1A1A'
                }} data-id="element-72">
                    cometer errores costosos
                  </strong>{' '}
                  con sus primeros huéspedes.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-73">
                <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-74">
                  ✓
                </span>
                <p style={{
                color: '#6B7280',
                fontFamily: 'Inter, sans-serif'
              }} className="text-base leading-relaxed" data-id="element-75">
                  Tienes un empleo de tiempo completo y{' '}
                  <strong style={{
                  color: '#1A1A1A'
                }} data-id="element-76">
                    no puedes responder mensajes durante el día
                  </strong>
                  .
                </p>
              </li>
            </ul>
          </div>

          {/* Not for who */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#E8E0D8]" data-id="element-77">
            <div className="flex items-center gap-3 mb-6" data-id="element-78">
              <span className="text-3xl" role="img" aria-label="No" data-id="element-79">
                🚫
              </span>
              <h3 className="text-xl font-bold" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-80">
                Esto NO es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-81">
              <li className="flex items-start gap-3" data-id="element-82">
                <span className="text-red-400 font-bold mt-0.5 flex-shrink-0" data-id="element-83">
                  ✗
                </span>
                <p style={{
                color: '#6B7280',
                fontFamily: 'Inter, sans-serif'
              }} className="text-base leading-relaxed" data-id="element-84">
                  Buscas una fórmula mágica para hacerte rico{' '}
                  <strong style={{
                  color: '#1A1A1A'
                }} data-id="element-85">
                    sin tener una propiedad real
                  </strong>
                  .
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-86">
                <span className="text-red-400 font-bold mt-0.5 flex-shrink-0" data-id="element-87">
                  ✗
                </span>
                <p style={{
                color: '#6B7280',
                fontFamily: 'Inter, sans-serif'
              }} className="text-base leading-relaxed" data-id="element-88">
                  No estás dispuesto a dedicar{' '}
                  <strong style={{
                  color: '#1A1A1A'
                }} data-id="element-89">
                    15 minutos a configurar tus mensajes automáticos
                  </strong>
                  .
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-90">
                <span className="text-red-400 font-bold mt-0.5 flex-shrink-0" data-id="element-91">
                  ✗
                </span>
                <p style={{
                color: '#6B7280',
                fontFamily: 'Inter, sans-serif'
              }} className="text-base leading-relaxed" data-id="element-92">
                  Eres un hotel grande con{' '}
                  <strong style={{
                  color: '#1A1A1A'
                }} data-id="element-93">
                    personal de recepción 24 horas
                  </strong>
                  .
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}